import { get } from 'axios';

const store = {
	namespaced: true,
	state: {
		primary: '',
		secondary: '',
		ad: '',
		headline: ''
	},
	mutations: {
		content(state, { prop, html }) {
			state[prop] = html;
		}
	},
	actions: {
		cms({ commit, state }, { prop, slug, isUpdate }) {
			if (!state[prop] || isUpdate) {
				get(`/service/cms/${slug}`).then(({ data }) => {
					commit('content', {
						prop,
						html: data.html
					});
				});
			}
		},
		fetchContent({ dispatch }, isUpdate) {
			dispatch('cms', {
				prop: 'primary',
				slug: 'verify-primary',
				isUpdate
			});

			dispatch('cms', {
				prop: 'secondary',
				slug: 'verify-secondary',
				isUpdate
			});

			dispatch('cms', {
				prop: 'ad',
				slug: 'verify-ad',
				isUpdate
			});

			dispatch('cms', {
				prop: 'headline',
				slug: 'verify-headline',
				isUpdate
			});
		}
	}
};

export default store;
